<template>
  <div class="question row">
    <div :class="typeView === 'view-result' ? 'col-xl-4 mb-4 mb-xl-0' : 'col-12'">
      <div class="card fill-preview-card mb-4">
        <div class="card-body">
          <homework-container :question="question"></homework-container>
        </div>
      </div>

      <div v-if="typeView === 'view-result'" class="card fill-comment-card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="section-heading mb-0 text-capitalize">Danh sách nhận xét</div>
            <div class="comment-counter">
              {{ detailComments.length }}
            </div>
          </div>

          <div v-if="detailComments.length" class="comment-list">
            <div
              v-for="(comment, indexComment) in detailComments"
              :key="indexComment"
              class="comment-card"
            >
              <div class="comment-card__header">
                <span>{{ indexComment + 1 }}. {{ truncateComment(comment.text) }}</span>
              </div>
              <div class="comment-card__body">
                {{ comment.feedback }}
              </div>
            </div>
          </div>

          <div v-else class="text-muted">Chưa có nhận xét.</div>
        </div>
      </div>
    </div>

    <div v-if="typeView === 'view-result'" class="col-xl-8">
      <div class="card fill-answer-card mb-4">
        <div class="card-body">
          <div class="section-heading mb-3">Bài làm học viên</div>
          <div class="answer-box">
            <span v-for="(item, index) in answerSegments" :key="'segment-' + index">
              <span v-if="item.type === 1" class="highlighted-text">{{ item.text }}</span>
              <span v-else>{{ item.text }}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="card fill-score-card">
        <div class="card-body">
          <div class="section-heading mb-4">Chấm bài</div>

          <div class="score-box">
            <div class="score-box__label">Điểm toàn bài</div>
            <div class="score-box__value-wrap">
              <el-rate
                class="admin-rate"
                size="large"
                :max="10"
                :show-score="true"
                :value="totalScore"
                :disabled="true"
                allow-half
              />
            </div>

            <div class="mt-4">
              <label class="field-label mb-2">Nhận xét</label>
              <div v-if="generalComments.length">
                <div v-for="(comment, index) in generalComments" :key="index" class="mb-3">
                  <div v-if="comment.type === 'file' && comment.totalScore" class="audio-box">
                    <audio controls class="audio-player clean-audio">
                      <source :src="normalizeUrl(comment.totalScore)" type="audio/wav">
                      <source :src="normalizeUrl(comment.totalScore)" type="audio/mpeg">
                      <source :src="normalizeUrl(comment.totalScore)" type="audio/ogg">
                      Trình duyệt không hỗ trợ phát audio.
                    </audio>
                  </div>
                  <div v-else class="comment-text-box">
                    <p class="comment-text">{{ comment.totalScore || '' }}</p>
                  </div>
                </div>
              </div>
              <div v-else class="comment-text-box">
                <p class="comment-empty">Không có nhận xét</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeworkContainer from './homework-container.vue'

export default {
  name: 'fill-reading',
  components: {
    homeworkContainer: homeworkContainer
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {}
      }
    },
    typeView: {
      type: String,
      default: ''
    }
  },
  computed: {
    outComes() {
      return this.question?.outComes || {}
    },
    totalScore() {
      return this.outComes?.score ?? 0
    },
    generalComments() {
      const commentsData = this.parseMaybeJson(this.outComes?.general_comments, [])
      if (Array.isArray(commentsData)) {
        return commentsData
      }

      if (this.outComes?.comment) {
        return [{ totalScore: this.outComes.comment, type: 'text' }]
      }

      return []
    },
    detailComments() {
      const detail = this.parseMaybeJson(this.outComes?.comments, [])
      return Array.isArray(detail) ? detail : []
    },
    studentAnswer() {
      return (this.question?.questions?.[0]?.student_answer || this.outComes?.answer || this.question?.student_answer || '').trim()
    },
    answerSegments() {
      const answers = this.studentAnswer
      if (!this.detailComments.length) {
        return [{ text: answers, type: 0 }]
      }

      const sortedComments = this.detailComments
        .slice()
        .filter((comment) => typeof comment.index === 'number' && comment.text)
        .sort((a, b) => a.index - b.index)

      const segments = []
      let cursor = 0

      sortedComments.forEach((comment) => {
        const start = Math.max(comment.index, cursor)
        const end = Math.min(comment.index + comment.text.length, answers.length)

        if (start > cursor) {
          segments.push({ text: answers.slice(cursor, start), type: 0 })
        }

        if (end > start) {
          segments.push({ text: answers.slice(start, end), type: 1 })
          cursor = end
        }
      })

      if (cursor < answers.length) {
        segments.push({ text: answers.slice(cursor), type: 0 })
      }

      return segments.length ? segments : [{ text: answers, type: 0 }]
    }
  },
  methods: {
    parseMaybeJson(value, fallback) {
      if (value === null || value === undefined || value === '') {
        return fallback
      }

      if (typeof value === 'string') {
        try {
          return JSON.parse(value)
        } catch (error) {
          return fallback
        }
      }

      return value
    },
    normalizeUrl(value) {
      if (!value || typeof value !== 'string') {
        return value || ''
      }

      if (value.indexOf('://') > -1 || value.indexOf('blob:') === 0 || value.indexOf('data:') === 0) {
        return value
      }

      return 'https://' + value
    },
    truncateComment(text) {
      if (!text) {
        return ''
      }
      return text.length > 40 ? text.substring(0, 40) + '...' : text
    }
  }
}
</script>

<style lang="scss" scoped>
.fill-preview-card,
.fill-comment-card,
.fill-answer-card,
.fill-score-card {
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem rgba(140, 152, 164, 0.08);
}

.section-heading {
  font-size: 1.05rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #3f4254;
  letter-spacing: 0.04em;
}

.score-box {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
}

.comment-counter {
  font-size: 1rem;
  font-weight: 700;
  color: #5867dd;
}

.comment-list {
  max-height: 420px;
  overflow-y: auto;
}

.comment-card {
  margin-bottom: 0.75rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  overflow: hidden;
}

.comment-card__header {
  padding: 0.75rem 1rem;
  background: linear-gradient(90deg, #5867dd 0%, #3699ff 100%);
  color: #fff;
  font-weight: 600;
}

.comment-card__body {
  padding: 1rem;
  background: #f8f9fc;
  color: #3f4254;
}

.answer-box {
  min-height: 360px;
  max-height: 420px;
  overflow-y: auto;
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #f8f9fc;
  white-space: pre-wrap;
  font-size: 0.975rem;
  color: #3f4254;
  line-height: 1.8;
}

.highlighted-text {
  background: #ffe27a;
  color: #1f1f1f;
}

.score-box__label,
.field-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3f4254;
}

.score-box__value-wrap {
  margin-top: 0.75rem;
}

.audio-box,
.comment-text-box {
  padding: 1rem;
  border: 1px solid #e4e6ef;
  border-radius: 0.75rem;
  background: #fff;
}

.audio-player {
  width: 100%;
  max-width: 420px;
}

.comment-text {
  margin-bottom: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

.comment-empty {
  margin-bottom: 0;
  color: #7e8299;
  font-style: italic;
}

.clean-audio,
.clean-audio:hover,
.clean-audio:focus,
.clean-audio:active {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  transform: none !important;
  -webkit-transform: none !important;
  -moz-transform: none !important;
  transition: none !important;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  outline: none !important;
}
</style>
